import '../translations'
import '../styles/tailwind-utilities.css'
import * as React from 'react'
import * as Sentry from '@sentry/react'
import { SENTRY_DSN } from '../Constants'
import { NewsCenter } from '../types'
import App from './containers/App'
import { Provider } from 'react-redux'
import store from './store'
import { ThemeProvider } from 'styled-components'

Sentry.init({
  dsn: SENTRY_DSN
})

interface IProps {
  news_center: NewsCenter
}

const ApplicationProvider = (props: IProps) => {
  const { news_center } = props

  return (
    <React.Suspense fallback={null}>
      <Provider store={store}>
        <ThemeProvider theme={{
          colors: {
            body: news_center.background_color,
            action: news_center.action_color,
            headerBackground: news_center.header_background_color,
            headerColor: news_center.header_text_color
          },
        }}>
          <App />
        </ThemeProvider>
      </Provider>
    </React.Suspense>
  )
}

export default ApplicationProvider